module.exports = __webpack_public_path__ + "img/father.19602405.svg";